/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import Button from '../elements/Button';

// Text-mark wordmark — see plan section 4 (Logo decision).
// Future Phase 8: swap with PNG/SVG logo asset when available.
export default function BrandIcon() {
  return (
    <Button className="" type="link" href="/">
      <p className="text-theme-blue text-2xl md:text-3xl font-serif font-bold leading-none">
        Balance Point
        <span className="block text-theme-purple text-base md:text-lg font-sans font-medium tracking-widest uppercase mt-1">
          Studios
        </span>
      </p>
    </Button>
  );
}
